/**
 * NO03 - Fakturakopi Actions
 */

import NO03, { NO03SearchParams } from '../../models/NO03';
import FirmNavnId from '../../models/FirmNavnId';
import * as actionTypes from './actionTypesNO03';

// Search Actions
export const NO03SearchRequest = (searchParams: NO03SearchParams) => {
  return {
    type: actionTypes.NO03_SEARCH_REQUEST,
    payload: searchParams,
  };
};

export const NO03SearchSuccess = (invoices: NO03[], totalAmount: number, hasMore: boolean) => {
  return {
    type: actionTypes.NO03_SEARCH_SUCCESS,
    payload: {
      invoices,
      totalAmount,
      hasMore,
    },
  };
};

export const NO03SearchFailure = (error: string) => {
  return {
    type: actionTypes.NO03_SEARCH_FAILURE,
    payload: error,
  };
};

// Clear/Reset Actions
export const NO03ClearResults = () => {
  return {
    type: actionTypes.NO03_CLEAR_RESULTS,
  };
};

export const NO03ResetForm = (isEnabled: boolean) => {
  return {
    type: actionTypes.NO03_RESET_FORM,
    payload: isEnabled,
  };
};

// Firma Actions
export const NO03SetFirma = (firma: FirmNavnId) => {
  return {
    type: actionTypes.NO03_SET_FIRMA,
    payload: firma,
  };
};

export const NO03LoadFirmaList = () => {
  return {
    type: actionTypes.NO03_LOAD_FIRMA_LIST,
  };
};

export const NO03LoadFirmaListSuccess = (firmaList: FirmNavnId[]) => {
  return {
    type: actionTypes.NO03_LOAD_FIRMA_LIST_SUCCESS,
    payload: firmaList,
  };
};

export const NO03LoadFirmaListFailure = (error: string) => {
  return {
    type: actionTypes.NO03_LOAD_FIRMA_LIST_FAILURE,
    payload: error,
  };
};

// Load More Actions (Pagination)
export const NO03LoadMoreRequest = (searchParams: NO03SearchParams) => {
  return {
    type: actionTypes.NO03_LOAD_MORE_REQUEST,
    payload: searchParams,
  };
};

export const NO03LoadMoreSuccess = (invoices: NO03[], hasMore: boolean) => {
  return {
    type: actionTypes.NO03_LOAD_MORE_SUCCESS,
    payload: {
      invoices,
      hasMore,
    },
  };
};

export const NO03LoadMoreFailure = (error: string) => {
  return {
    type: actionTypes.NO03_LOAD_MORE_FAILURE,
    payload: error,
  };
};

// Component Store Management
export const NO03ClearComponentStore = () => {
  return {
    type: actionTypes.NO03_CLEAR_COMPONENT_STORE,
  };
};
